import { getLocality } from '../../api/api';
import isEmpty from '../../vibe/components/utilities/MainUtils/is-empty';
import _ from 'lodash';

export const ADD_SUBJECT = 'ADD_SUBJECT';
export const DELETE_SUBJECT = 'DELETE_SUBJECT';
export const CLEAR_SUBJECT = 'CLEAR_SUBJECT';
export const EDIT_SUBJECT = 'EDIT_SUBJECT';
export const SAVE_EDIT_SUBJECT = 'SAVE_EDIT_SUBJECT';
export const SET_SUBJECT = 'SET_SUBJECT';
export const MERCHANT_NAME = 'MERCHANT_NAME';
export const AGENT_SURNAME = 'AGENT_SURNAME';
export const AGENT_NAME = 'AGENT_NAME';
export const AGENTPAT_RONYMIC = 'AGENTPAT_RONYMIC';
export const PHONE = 'PHONE';
export const EMAIL = 'EMAIL';
export const REGION = 'REGION';
export const SPSZN = 'SPSZN';
export const REQUEST_LOCALITY = 'REQUEST_LOCALITY';
export const SUCCESS_LOCALITY = 'SUCCESS_LOCALITY';

export const SET_CURRENT_USER = 'SET_CURRENT_USER';

export const COMMUNITY_NAME = 'COMMUNITY_NAME';
export const ADDRESS = 'ADDRESS';
export const COMMUNITY_PHONE = 'COMMUNITY_PHONE';
export const COMMUNITY_EMAIL = 'COMMUNITY_EMAIL';
export const COMMUNITY_URL = 'COMMUNITY_URL';
export const COMMUNITY_COUNT = 'COMMUNITY_COUNT';
export const I_CODE_RADA = 'I_CODE_RADA';
export const ERROR_LOCALITY = 'ERROR_LOCALITY';

export const addSubjects = (data) => ({
  type: ADD_SUBJECT,
  payload: data,
});

export const setSubjects = (data) => ({
  type: SET_SUBJECT,
  payload: data,
});

export const editSubject = (data) => ({
  type: EDIT_SUBJECT,
  payload: data,
});

export const saveEditableSubject = (data, index) => ({
  type: SAVE_EDIT_SUBJECT,
  payload: { data, index },
});

export const deleteSubject = (index) => ({
  type: DELETE_SUBJECT,
  payload: index,
});

export const clearSubject = () => ({
  type: CLEAR_SUBJECT,
});

export const setLocality = (data) => {
  return {
    type: SUCCESS_LOCALITY,
    payload: data,
  };
};

// function memoize(method) {
//     let cache = {};

//     return async function() {
//         let args = JSON.stringify(arguments);
//         cache[args] = cache[args] || method.apply(this, arguments);
//         return cache[args];
//     };
// }

const getCache = () => {
  if (localStorage.localStorage) {
    return JSON.parse(localStorage.getItem('localStorage'));
  } else {
    return {};
  }
};

const setCache = (region, data) => {
  const objFromStorage = getCache();
  const obj = { ...objFromStorage, [region]: data };
  localStorage.setItem('cacheRegion', JSON.stringify(obj));
};

export const localityAction = (region) => async (dispatch, getState) => {
  const cache = getCache();

  console.log(_.isEmpty(cache[region]));

  if (!isEmpty(cache[region])) {
    console.log('Hello from cache', cache[region]);
    dispatch(setLocality(cache[region]));
  } else {
    try {
      const response = await getLocality(region);
      dispatch(setLocality(response.data));
      console.log('cache me');
      setCache(region, response.data);
    } catch (err) {
      dispatch({ type: ERROR_LOCALITY });
    }
  }
};

export const socialComunitiAction = (type, value) => {
  switch (type) {
    case 'merchantName':
      return {
        type: MERCHANT_NAME,
        payload: value,
      };
    case 'agentSurname':
      return {
        type: AGENT_SURNAME,
        payload: value,
      };
    case 'agentName':
      return {
        type: AGENT_NAME,
        payload: value,
      };
    case 'agentPatronymic':
      return {
        type: AGENTPAT_RONYMIC,
        payload: value,
      };
    case 'phone':
      return {
        type: PHONE,
        payload: value,
      };
    case 'email':
      return {
        type: EMAIL,
        payload: value,
      };
    case 'regionId':
      return {
        type: REGION,
        payload: value,
      };
    case 'spsznId':
      return {
        type: SPSZN,
        payload: value,
      };
    case 'communityName':
      return {
        type: COMMUNITY_NAME,
        payload: value,
      };
    case 'address':
      return {
        type: ADDRESS,
        payload: value,
      };
    case 'communityPhone':
      return {
        type: COMMUNITY_PHONE,
        payload: value,
      };
    case 'communityEmail':
      return {
        type: COMMUNITY_EMAIL,
        payload: value,
      };
    case 'url':
      return {
        type: COMMUNITY_URL,
        payload: value,
      };
    case 'count':
      return {
        type: COMMUNITY_COUNT,
        payload: value,
      };
    case 'iCodeRada':
      return {
        type: I_CODE_RADA,
        payload: value,
      };
    default:
      return value;
  }
};
